export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_FAIL = "REGISTER_FAIL";
export const SET_USER = "SET_USER";
export const AUTH_ERROR = "AUTH_ERROR";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGOUT = "LOGOUT";
export const ADD_LISTING = "ADD_LISTING";
export const GET_LISTINGS = "GET_LISTINGS";
export const LISTING_ERROR = "LISTING_ERROR";
export const EDIT_LISTING = "EDIT_LISTING";
export const SET_LISTING = "SET_LISTING";
export const DELETE_LISTING = "DELETE_LISTING";
export const ADD_TO_CART = "ADD_TO_CART";
export const DELETE_FROM_CART = "DELETE_FROM_CART";
